var default_styles_default = {
  "button_container": "dy7IS",
  "button_margin": "s9o44",
  "button_text": "g8mRy",
  "button_size_content": "E0r4y"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
